export default "__VITE_ASSET__CCLzCzgH__"